"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SideBar = void 0;
var _react = require("react");
var _hooks = require("../../../hooks");
var _SideBar = require("./SideBar.labels");
var _SideBarListItem = require("./Partials/SideBarListItem");
var _Menu = require("../../../UI/Menu");
var _Icon = require("../../../UI/Icon");
var _Site = require("../Site.config");
var _SideBar2 = _interopRequireDefault(require("./SideBar.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var SideBar = function SideBar(props) {
  var items = props.items,
    _props$maxMobileItems = props.maxMobileItems,
    maxMobileItems = _props$maxMobileItems === void 0 ? 5 : _props$maxMobileItems,
    _props$expandOnHover = props.expandOnHover,
    expandOnHover = _props$expandOnHover === void 0 ? false : _props$expandOnHover;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem;
  var getLabel = (0, _hooks.useLabels)({
    labels: _SideBar.labels
  });
  var styles = (0, _SideBar2.default)(expandOnHover);
  var menuRef = (0, _react.useRef)(null);
  var btnProps = {};
  var listItems = _toConsumableArray(items);
  var menuItems = [];
  if (isMobileView && listItems.length > maxMobileItems) {
    listItems = items.slice(0, maxMobileItems - 1);
    menuItems = items.slice(maxMobileItems - 1);
    btnProps = {
      shape: 'rectangle',
      view: 'alternate',
      color: 'basic',
      customStyle: {
        width: '100%',
        height: pxToRem(_Site.sidebarHeight)
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: styles['cc-SideBar__menu__item__more-btn'],
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          name: "More"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          children: getLabel('more')
        })]
      })
    };
  }
  var handleItemClick = function handleItemClick() {
    if (menuRef.current) {
      menuRef.current.closeMenu();
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("aside", {
      className: styles['cc-SideBar'],
      "aria-label": getLabel('sidebarAriaLabel'),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("nav", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("ul", {
          className: styles['cc-SideBar__menu'],
          children: [listItems && listItems.map(function (item, i) {
            var itemProps = {
              item: item,
              expandOnHover: expandOnHover
            };
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SideBarListItem.SideBarListItem, _objectSpread({}, itemProps), i);
          }), isMobileView && menuItems.length && /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
            className: styles['cc-SideBar__menu__item'],
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Menu.Menu, {
              btnProps: btnProps,
              anchorWidth: "auto",
              ref: menuRef,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
                className: styles['cc-SideBar__menu__item__more-menu'],
                children: menuItems.map(function (item, i) {
                  var itemProps = {
                    item: item,
                    isMoreMenuItem: true,
                    onItemClick: handleItemClick
                  };
                  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SideBarListItem.SideBarListItem, _objectSpread({}, itemProps), i);
                })
              })
            })
          })]
        })
      })
    })
  });
};
exports.SideBar = SideBar;